export default "__VITE_ASSET__BAM6UZxW__"